<db-dialog-wrapper [dialog]="this" [width]="width">
  <div class="agency-partner-program-dialog">
    <div class="agency-partner-program-dialog__header" [innerHTML]="title"></div>
    <div class="agency-partner-program-dialog__message" [innerHTML]="body">
    </div>
    <div class="db-confirm-dialog__buttons">
      <a class="db-button db-button_info" (click)="confirm()">
        <span [innerHTML]="btn ? btn : 'GOT IT'"></span>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
